import session from './session';
import store from '@/store/index';
import App from "@/App.vue";

class BaseApiService {
    baseUrl = process.env.VUE_APP_REST_BASE_URL;
    resource;
    caching= false;
    cache = {};

    constructor(resource, caching=false) {
        if (!resource) throw new Error("Resource is not provided");
        this.resource = resource;
        this.caching = caching;
    }

    getUrl(id = "") {
        let rv = `${this.baseUrl}/${this.resource}/`;
        if (id) {
            rv = rv + `${id}/`;
        }
        return rv;
    }

    handleErrors(err) {
        console.log({ message: "Errors are handled here", err});
        store.commit('toast/addToast', {
            title: 'Input/Output Error',
            type: 'is-danger',
            message: 'There is a problem reported by Network/Database connection: ' + err,
        })

    }
}

class ReadOnlyApiService extends BaseApiService {
    constructor(resource, caching=false) {
        super(resource, caching);
    }

    async fetch(config = {}) {
        try {
            let get_parameter = '';
            let url = '';
            // console.log("config.page ist: ", config.page);
            if (config.page) {
                url = config.page;
            } else {
                for (const [key, value] of Object.entries(config)) {
                    console.log("fetch - filter: ", key, value)
                    if (value !== null && value !== undefined) {
                        if (get_parameter.length === 0) {
                            get_parameter = get_parameter + "?";
                        } else {
                            get_parameter = get_parameter + '&';
                        }
                        get_parameter = get_parameter + key + "=" + value
                    }
                }
                url = this.getUrl();
                if (get_parameter.length > 0 ) {
                    url = url + get_parameter;
                }
            }
            console.log("Requesting with URL to fetch:", url);
            if (this.caching) {
                if (this.cache[url]) {
                    console.log("Take response for url ", url, " from cache.")
                    return this.cache[url];
                }
            }
            const locale = localStorage.getItem('user-locale')
            session.defaults.headers.common['Accept-Language'] = locale;
            console.log("session/headers", session.defaults.headers.common);
            // session.headers['Accepted-Language'] = locale;
            const response = await session.get(url);
            if (this.caching) {
                // put response.data in cache, key is url
                console.log("Caching response for url ", url);
                this.cache[url] = response.data;
            }
            return await response.data;
        } catch (err) {
            this.handleErrors(err);
        }
    }

    async get(id, extra_action=false, extra_parameter="") {
        try {
            if (!id) throw Error("REST-API: Id is not provided, but mandatory for get request.");
            let getUrl = this.getUrl(id)
            if (extra_action) {
                getUrl = getUrl + extra_action + "/" + extra_parameter
            }
            console.log("Requesting with URL to get:", getUrl);
            const response = await session.get(getUrl);
            return await response.data;
        } catch (err) {
            this.handleErrors(err);
        }
    }

    async options() {
        try {
            const response = await session.options(this.getUrl());
            return await response.data;
        } catch (err) {
            this.handleErrors(err);
        }
    }
}

class ModelApiService extends ReadOnlyApiService {
    constructor(resource, caching=false) {
        super(resource, caching);
    }

    async post(data = {}, is_form_data = false) {
        try {
            let config = {};
            if (is_form_data) {
                config = {
                    headers: {
                        "Content-Type": "multipart/form-data",
                    }
                }
            }
            const response = await session.post(this.getUrl(), data, config
            ).catch(function(error) {
                if (error.response) {
                    store.commit('toast/addToast', {
                        title: "Mad Server response",
                        type: 'is-danger',
                        message: error.response.data,
                    });
                } else if (error.request) {
                    store.commit('toast/addToast', {
                        title: "No Server response",
                        type: 'is-danger',
                        message: error.request,
                    });
                } else {
                    store.commit('toast/addToast', {
                        title: "Something Bad happened",
                        type: 'is-danger',
                        message: error.message,
                    });
                }
            });
            const { id } = response.data;
            return id;
        } catch (err) {
            this.handleErrors(err);
        }
    }

    async put(id, data = {}, is_form_data = false, extra_action= false) {
        if (!id) throw Error("Id is not provided.");
        try {
            console.log(data);
            let config = {};
            if (is_form_data) {
                config = {
                    headers: {
                        "Content-Type": "multipart/form-data",
                    }
                }
            }
            let getUrl = this.getUrl(id);
            if (extra_action) {
                getUrl = getUrl + extra_action + "/"
            }
            const response = await session.put(getUrl, data, config
            ).catch(function(error) {
                if (error.response) {
                    store.commit('toast/addToast', {
                        title: "Mad Server response",
                        type: 'is-danger',
                        message: error.response.data,
                    });
                } else if (error.request) {
                    store.commit('toast/addToast', {
                        title: "No Server response",
                        type: 'is-danger',
                        message: error.request,
                    });
                } else {
                    store.commit('toast/addToast', {
                        title: "Something Bad happened",
                        type: 'is-danger',
                        message: error.message,
                    });
                }
            });
            const { id: responseId } = response.data;
            return responseId;
        } catch (err) {
            this.handleErrors(err);
        }
    }

    async delete(id) {
        if (!id) throw Error("Id is not provided.");
        try {
            await session.delete(this.getUrl(id)).catch(function(error) {
                if (error.response) {
                    store.commit('toast/addToast', {
                        title: "Mad Server response",
                        type: 'is-danger',
                        message: error.response.data,
                    });
                } else if (error.request) {
                    store.commit('toast/addToast', {
                        title: "No Server response",
                        type: 'is-danger',
                        message: error.request,
                    });
                } else {
                    store.commit('toast/addToast', {
                        title: "Something Bad happened",
                        type: 'is-danger',
                        message: error.message,
                    });
                }
            });
            return true;
        } catch (err) {
            this.handleErrors(err);
        }

    }
}

class UserModelApiService extends ModelApiService {
   async get(id) {
       const data = await super.get(id);
       // set the balance in the store, that makes it very reactive!
       const ui = store.getters['auth/getUserInfo'];
       console.log('api for User: check for balance...', ui.pk, id)
       if (ui.pk === id) {
           // do it only, if the get is for the loggedin - User
           console.log("set new balance to ", data.balance)
           const balance = data.balance
           store.dispatch('auth/setBalance', { balance })
       }
       return data;
    }
}

class KpisApiService extends ModelApiService { constructor() { super("kpis", true); } }
class KpiClassApiService extends ModelApiService { constructor() { super("kpiclasses", true); } }
class KpiTypeApiService extends ModelApiService { constructor() { super("kpitypes", true); } }
class AssessmentTemplateApiService extends ModelApiService { constructor() { super("assessmenttemplates"); } }
class AssessmentTemplateKpiApiService extends ModelApiService { constructor() { super("assessmenttemplatekpis"); } }
class ProjectApiService extends ModelApiService { constructor() { super("projects") } }
class UploadedFileService extends ModelApiService { constructor() { super('uploadedfiles') } }
class ProjectDocumentService extends ModelApiService { constructor() { super('projectdocuments') } }
class CountryService extends ModelApiService { constructor() { super('countries', true) } }
class SectorService extends ModelApiService { constructor() { super('sectors', true) } }
class IntentionService extends ModelApiService { constructor() { super('intentions', true) } }
class BuddyService extends ModelApiService { constructor() { super('buddys') } }
class BuddySectionService extends ModelApiService { constructor() { super('buddysections') } }
class BuddyStepService extends ModelApiService { constructor() { super('buddysteps') } }
class BuddyElementService extends ModelApiService { constructor() { super('buddyelements') } }
class SuggestionService extends ModelApiService { constructor() { super('suggestions') } }
class SuggestionDepartmentService extends ModelApiService { constructor() { super('suggestiondeparments', true) } }
class SuggestionCategoryService extends ModelApiService { constructor() { super('suggestioncategories', true) } }
class SuggestionGoodFor extends ModelApiService { constructor() { super('suggestiongoodfor', true) } }
class News extends ModelApiService { constructor() { super('news') } }
class NewsScope extends ModelApiService { constructor() { super('newsscopes', true) } }
class NewsSource extends ModelApiService { constructor() { super('newssources') } }
class NewsStatus extends ModelApiService { constructor() { super('newsstatus') } }
class NewsCategory extends ModelApiService { constructor() { super('newscategories') } }
class Organizations extends ModelApiService { constructor() { super('organizations') } }
class OrganizationClass extends ModelApiService { constructor() { super('organizationclasses', true) } }
class OrganizationTypes extends ModelApiService { constructor() { super('organizationtypes', true) } }
class Providers extends ModelApiService { constructor() { super('providers') } }
class ProjectCollaborators extends ModelApiService { constructor() { super('projectcollaborators') }}
class ProjectDelegates extends ModelApiService { constructor() { super('projectdelegates') }}
class ProjectKpis extends ModelApiService { constructor() { super('projectkpis') }}
class ProjectKpiTasks extends ModelApiService { constructor() { super('projectkpitasks') }}
class ProjectKpiTaskHists extends ModelApiService { constructor() { super('projectkpitaskhists') }}
class ProjectKpiTaskResults extends ModelApiService { constructor() { super('projectkpitaskresults') }}
class ProjectKpiTaskResultAttachments extends ModelApiService { constructor() { super('projectkpitaskresultattachments') }}
class ProjectKpiTaskBudgets extends ModelApiService { constructor() { super('projectkpitaskbudgets') }}
class ProjectKpiTaskAttachments extends ModelApiService { constructor() { super('projectkpitaskattachments') }}
class ValidFors extends ModelApiService { constructor() { super('validfors', true) }}
class Periods extends ModelApiService { constructor() { super('periods', true) }}
class BudgetTypes extends ModelApiService { constructor() { super('budgettypes', true) }}
class Users extends UserModelApiService { constructor() { super('users') }}
class Groups extends ModelApiService { constructor() { super('groups') }}
class BlogPosts extends ModelApiService { constructor() { super('blogposts') }}
class Transactions extends ModelApiService { constructor() { super('transactions') }}
class Languages extends ModelApiService { constructor() { super('languages', true) }}
class Surveys extends ModelApiService { constructor() { super('surveys')}}
class SurveyAnswerType extends ModelApiService { constructor() { super('surveyanswertypes', true) }}
class IntSurveys extends ModelApiService { constructor() { super('intsurveys')}}
class IntSurveyPages extends ModelApiService { constructor() { super('intsurveypages')}}
class IntSurveyQuestions extends ModelApiService { constructor() { super('intsurveyquestions')}}
class IntSurveyAnswersMultipleChoice extends ModelApiService { constructor() { super('intsurveyanswermultiplechoices')}}
class AnswerType extends ModelApiService { constructor() { super('answertypes')}}
class Campaigns extends ModelApiService { constructor() { super('campaigns')}}
class CampaignsParticipants extends ModelApiService { constructor() { super('campaignparticipants')}}
class CSurveyAnswert extends ModelApiService {constructor() { super('csurveyanswers')}}
class CSurveyAnswerAttachment extends ModelApiService {constructor() { super('csurveyanswerattachments')}}
class Notification extends ModelApiService {constructor() { super('notifications')}}
class NotificationType extends ModelApiService {constructor() { super('notificationtypes')}}
class Application extends ModelApiService {constructor() { super('applications')}}
class ApplicationAnswer extends ModelApiService {constructor() { super('applicationanswers')}}
class SelfAssessment extends ModelApiService {constructor() { super('selfassessments')}}
class SelfAssessmentItem extends ModelApiService {constructor() { super('selfassessmentitems')}}
class SelfAssessmentApplicability extends ModelApiService {constructor() { super('selfassessmentapplicabilitys', true)}}
class SelfAssessmentAnswer extends ModelApiService {constructor() { super('selfassessmentanswers')}}
class SelfAssessmentAnswerAttachment extends ModelApiService {constructor() { super('selfassessmentanswerattachments')}}
class ImpactStore extends ModelApiService{constructor() {super('impactstores', true)}}
class Years extends ModelApiService{constructor() {super('years', true)}}
class Results extends ReadOnlyApiService{constructor() {super('results', false)}}
class NewsAI extends ModelApiService{constructor() {super('newsai', false)}}



const api = {
    kpis: new KpisApiService(),
    kpiclass: new KpiClassApiService(),
    kpitypes: new KpiTypeApiService(),
    assessmenttemplates: new AssessmentTemplateApiService(),
    assessmenttemplatekpis: new AssessmentTemplateKpiApiService(),
    projects: new ProjectApiService(),
    projectdocuments: new ProjectDocumentService(),
    uploadedfiles: new UploadedFileService(),
    countries: new CountryService(),
    sectors: new SectorService(),
    intentions: new IntentionService(),
    buddies: new BuddyService(),
    buddysections: new BuddySectionService(),
    buddystep: new BuddyStepService(),
    buddyelement: new BuddyElementService(),
    suggestions: new SuggestionService(),
    suggestioncategories: new SuggestionCategoryService(),
    suggestiondepartments: new SuggestionDepartmentService(),
    suggestiongoodfor: new SuggestionGoodFor(),
    news: new News(),
    newsscopes: new NewsScope(),
    newssources: new NewsSource(),
    newsstatus: new NewsStatus(),
    newscategories: new NewsCategory(),
    organizations: new Organizations(),
    organizationclasses: new OrganizationClass(),
    organizationtypes: new OrganizationTypes(),
    providers: new Providers(),
    projectcollaborators: new ProjectCollaborators(),
    projectdelegates: new ProjectDelegates(),
    projectkpis: new ProjectKpis(),
    projectkpitasks: new ProjectKpiTasks(),
    projectkpitaskresults: new ProjectKpiTaskResults(),
    projectkpitaskresultattachments: new ProjectKpiTaskResultAttachments(),
    projectkpitaskhists: new ProjectKpiTaskHists(),
    projectkpitaskattachments: new ProjectKpiTaskAttachments(),
    projectkpitaskbudgets: new ProjectKpiTaskBudgets(),
    validfors: new ValidFors(),
    periods: new Periods(),
    budgettypes: new BudgetTypes(),
    users: new Users(),
    groups: new Groups(),
    blogposts: new BlogPosts(),
    transactions: new Transactions(),
    languages: new Languages(),
    surveys: new Surveys(),
    surveyanswertypes: new SurveyAnswerType(),
    intsurveys: new IntSurveys(),
    intsurveypages: new IntSurveyPages(),
    intsurveyquestions: new IntSurveyQuestions(),
    intsurveyanswermultiplechoice: new IntSurveyAnswersMultipleChoice(),
    answertypes: new AnswerType(),
    campaigns: new Campaigns(),
    campaignparticipants: new CampaignsParticipants(),
    csurveyanswers: new CSurveyAnswert(),
    csurveyanswerattachments: new CSurveyAnswerAttachment(),
    notifications: new Notification(),
    notificationtypes: new NotificationType(),
    applications: new Application(),
    applicationanswers: new ApplicationAnswer(),
    selfassessments: new SelfAssessment(),
    selfassessmentitems: new SelfAssessmentItem(),
    selfassessmentapplicabilitys: new SelfAssessmentApplicability(),
    selfassessmentanswers: new SelfAssessmentAnswer(),
    selfassessmentanswerattachments: new SelfAssessmentAnswerAttachment(),
    impactstores: new ImpactStore(),
    years: new Years(),
    results: new Results(),
    newsai: new NewsAI(),
}
export default api